module.exports = __webpack_public_path__ + "static/media/logo-dark.fc390b40.webp";